import Typography from '@mui/material/Typography';
import React, {ReactNode} from 'react';
import {sx} from './sx'
import RouteArrowSvgIcon from "@resource/svg/RouteArrowSvgIcon";
import {sliceString} from "@helpers/string";
import TooltipCustom from "@ui/tooltipCustom/TooltipCustom";
import {SxType} from "@baseTypes/sx/sxTypes";

interface IProps {
    name: string,
    sx?: SxType,
    icon?: ReactNode,
    maxNameLength?: number
}

const NameInfoBackBarSingleVoyage = ({
                      name,
                      sx: sxProps = {},
                      icon,
                      maxNameLength = 20
}: IProps) => {
    return (
        <Typography
            sx={{
                ...sx.root,
                ...sxProps,
            }}
        >
            {icon ?? <RouteArrowSvgIcon/>}

            <TooltipCustom
                title={name}
            >
                {sliceString(name, maxNameLength)}
            </TooltipCustom>
        </Typography>
    );
};

export default NameInfoBackBarSingleVoyage;